import { render, staticRenderFns } from "./Gsxx.vue?vue&type=template&id=a4205ab4&scoped=true&"
import script from "./Gsxx.vue?vue&type=script&lang=js&"
export * from "./Gsxx.vue?vue&type=script&lang=js&"
import style0 from "./Gsxx.vue?vue&type=style&index=0&id=a4205ab4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4205ab4",
  null
  
)

export default component.exports